// biome-ignore lint/complexity/noExcessiveCognitiveComplexity: light/dark palette branching is inherent
export const getCustomPalette = (dark: boolean) => ({
	info: {
		main: dark ? "#29b6f6" : "#0288d1",
		light: dark ? "#4fc3f7" : "#03a9f4",
		dark: dark ? "#0288d1" : "#01579b",
	},
	success: {
		main: dark ? "#4CAF50" : "#2E7D32",
		light: dark ? "#81C784" : "#2E7D32",
		dark: dark ? "#388E3C" : "#1B5E20",
		info: dark ? "rgba(102, 187, 104, 1)" : "rgba(187, 240, 181, 1)",
	},
	warning: {
		main: dark ? "#ED6C02" : "#ED6C02",
		light: dark ? "#FF9800" : "#FF9800",
		dark: dark ? "#E65100" : "#E65100",
	},
	error: {
		main: dark ? "#FF4D4D" : "#EB0014",
		light: dark ? "#FF9999" : "#EB0014",
		dark: dark ? "#CC0000" : "#C70011",
		info: dark ? "rgba(255, 180, 180, 1)" : "rgba(255, 220, 220, 1)",
	},
	divider: dark ? "rgba(255,255,255,0.12)" : "rgba(0,0,0,0.12)",
	answer: {
		selected: {
			border: "#6da3eb",
			background: "rgba(109, 163, 235, 0.15)",
		},
		correct: {
			border: "#66bb67",
			background: "rgba(102, 187, 103, 0.15)",
		},
		incorrect: {
			border: "#d66565",
			background: "rgba(214, 101, 101, 0.15)",
		},
	},
	confidence: {
		high: "#66bb68",
		medium: "#dda53a",
		low: "#d66565",
	},
	progress: {
		high: "#66bb68",
		medium: "#dda53a",
		low: "#d66565",
		none: dark ? "#757575" : "#ddd",
		noneBackground: "#888888",
		lowBackground: "rgba(255,105,97, 0.3)",
		highBackground: "rgba(0, 168, 106, 0.3)",
	},
	leader: {
		gold: "#FFD336",
	},
	calculator: {
		background: "#2a2a2a",
		displayBackground: "#404040",
		inputTextColor: "#00ff00",
		operationTextColor: "#00ffff",
		resultTextColor: "#ffff00",
		memoryTextColor: "#ff9900",
	},
	yellow: {
		main: dark ? "#FFEB3B" : "#FBC02D",
		light: dark ? "#FFFF72" : "rgba(240, 255, 150, 0.3)",
		dark: dark ? "#B2A300" : "#F57F17",
	},
	purple: {
		main: dark ? "#B964F7" : "#800080",
		light: dark ? "#D4A4F7" : "#800080",
		dark: dark ? "#9932CC" : "#4B0082",
	},
	highlight: {
		main: "#FFDACA",
		light: "#F1FF91",
		quote: "#FF8F60",
	},
	chips: {
		free: dark ? "#2E7D32" : "#81C784",
		freeText: dark ? "#FFFFFF" : "#1B5E20",
		premium: "#FFD700",
		premiumText: "#000000",
	},
});

export const textColors = (dark: boolean) => ({
	primary: dark ? "rgba(255,255,255,0.87)" : "rgba(0,0,0,0.87)",
	secondary: dark ? "rgba(255,255,255,0.60)" : "rgba(0,0,0,0.60)",
	disabled: dark ? "rgba(255,255,255,0.38)" : "rgba(0,0,0,0.38)",
});
